import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { DialogSpinnerDownloadComponent } from './dialog-spinner-download.component';

@NgModule({
	declarations: [DialogSpinnerDownloadComponent],
	imports: [CommonModule, MatProgressSpinnerModule]
})
export class DialogSpinnerDownloadModule {}
